import styled, { css } from 'styled-components';
import { device } from 'modules/Utils/Devices';

const Container = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;

  ${(props) =>
    !props.$isMobile &&
    css`
      gap: 0.8rem;
      margin-right: 2.4rem;
      padding-right: 2.4rem;
      border-right: 0.1rem solid ${props.theme.config.colors.gray_300};

      @media ${device.tablet} {
        gap: 0.4rem;
        margin-right: 1.6rem;
        padding-right: 1.6rem;
      }
    `}

  ${(props) =>
    props.$isMobile &&
    css`
      flex-wrap: wrap;
      column-gap: 0.8rem;
      row-gap: 0.2rem;
      margin-top: 0.2rem;
    `}
`;

const Item = styled.span`
  ${(props) => props.theme.config.typograph.mico};
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  white-space: nowrap;

  & + & {
    &::before {
      content: '•';
      margin-right: 0.4rem;
      color: ${(props) =>
        props.$isMobile
          ? props.theme.config.colors.gray_400
          : props.theme.config.colors.gray_300};
    }
  }
`;

const Label = styled.span`
  color: ${(props) =>
    props.$isMobile
      ? props.theme.config.colors.gray_400
      : props.theme.config.colors.text_base};
`;

const Value = styled.strong`
  font-weight: 700;
  color: ${(props) =>
    props.$isMobile
      ? props.theme.config.colors.light
      : props.theme.config.colors.gray_900};
`;

export { Container, Item, Label, Value };
